/**
 * Tester review 2026-09-28 — Spanish source texts (taken from the review document).
 * Merged last by uiStrings.ts, so these keys override the earlier dictionaries.
 */
export const V2_ES: Record<string, string> = {
  // Home
  'home.heading': '¿Tienes una consulta, sugerencia o preocupación sobre el Proyecto?',
  'home.subheading': 'Queremos escucharte.',
  'home.intro': 'Este es el canal del Proyecto “Jubilación Segura” para hacer consultas, compartir sugerencias, expresar preocupaciones o presentar quejas y reclamos relacionados con sus actividades, impactos, beneficios o implementación.',
  'home.mechanism': 'Todas las comunicaciones serán recibidas y evaluadas de acuerdo con el Mecanismo de atención del Proyecto.',
  'home.privacy': 'Tu privacidad es importante para nosotros. Puedes presentar tu solicitud de manera anónima. Si decides proporcionar tus datos personales, estos serán utilizados únicamente para gestionar tu solicitud y comunicarnos contigo, de acuerdo con nuestra Política de protección de datos.',
  'home.start': 'Iniciar solicitud',

  // Type of record
  'form.type.heading': '¿Cómo quieres presentar tu solicitud?',
  'form.type.identified.title': 'Quiero dejar mis datos de contacto',
  'form.type.identified.desc': 'Registras tus datos personales y de contacto (por ejemplo, nombre y teléfono). El equipo del Proyecto podrá comunicarse contigo durante la evaluación de tu solicitud y para brindarte una respuesta.\nPodrás consultar el estado de tu solicitud mediante el código de seguimiento.',
  'form.type.anonymous.title': 'Quiero mantener mi solicitud anónima',
  'form.type.anonymous.desc': 'No es necesario registrar tus datos personales. Tu solicitud será recibida y evaluada de acuerdo con el Mecanismo de Atención del Proyecto. Al no proporcionar tus datos de contacto, no podremos comunicarnos contigo directamente ni enviarte una respuesta personalizada.\nPodrás utilizar tu código de seguimiento para consultar el estado de tu solicitud.',

  // Requester
  'form.requester.heading': '¿Cómo podemos comunicarnos contigo?',
  'form.requester.notice': 'Estos datos nos permitirán comunicarnos contigo para dar seguimiento a tu solicitud y brindarte una respuesta.',
  'form.requester.fullName': 'Nombre y Apellido / Nombre de organización',
  'form.requester.gender': 'Género',
  'form.requester.gender.M': 'Hombre',
  'form.requester.gender.F': 'Mujer',
  'form.requester.contactPrompt': '¿Cómo prefieres que te contactemos?',
  'form.requester.phone': 'Teléfono / WhatsApp',
  'form.requester.phonePlaceholder': 'Ej. 999 999 999',
  'form.requester.email': 'Correo electrónico',
  'form.requester.emailPlaceholder': 'Ej. nombre@correo.com',
  'form.requester.contactHint': 'Indica al menos un medio de contacto.',
  'form.requester.idHeading': 'Documento de identidad (opcional)',
  'form.requester.idDocumentType': 'Tipo de documento',
  'form.requester.id.RUC': 'RUC (Persona Jurídica)',
  'form.requester.idNotice': 'No es necesario proporcionar tu documento de identidad para presentar una solicitud. Si decides proporcionarlo, será utilizado únicamente para gestionar tu solicitud, de acuerdo con la Política de Protección de Datos.',

  // Request
  'form.request.heading': '¿Qué deseas comunicar al Proyecto?',
  'form.request.headingHelp': 'Si no estás seguro de cuál elegir, selecciona la opción que consideres más cercana a tu situación.',
  'form.request.category': 'Tipo de solicitud',
  'category.CONSULTA': 'Consulta o solicitud de información',
  'category.SUGERENCIA': 'Sugerencia o propuesta',
  'category.PREOCUPACION': 'Preocupación o alerta',
  'category.QUEJA_RECLAMO': 'Queja o reclamo',
  'form.request.categoryHelp.CONSULTA': 'Quiero realizar una pregunta, aclarar una situación o solicitar información sobre el Proyecto.',
  'form.request.categoryHelp.SUGERENCIA': 'Quiero compartir una idea, recomendación o propuesta para mejorar las actividades del Proyecto.',
  'form.request.categoryHelp.PREOCUPACION': 'Quiero comunicar una situación que me preocupa y que considero que debería ser conocida o revisada por el Proyecto.',
  'form.request.categoryHelp.QUEJA_RECLAMO': 'Quiero expresar mi disconformidad o inconformidad con una situación, actividad, decisión o impacto relacionado con el Proyecto. ¿Qué ocurrió? ¿Cuándo? ¿Dónde? ¿Quiénes están involucrados?',
  'form.request.descTitle': 'Cuéntanos sobre tu solicitud',
  'form.request.descLabel.CONSULTA': '¿Qué información necesitas o qué deseas aclarar?',
  'form.request.descLabel.SUGERENCIA': '¿Qué propuesta o mejora deseas compartir?',
  'form.request.descLabel.PREOCUPACION': '¿Qué situación te preocupa?',
  'form.request.descLabel.QUEJA_RECLAMO': '¿Qué ocurrió y cuál es tu preocupación?',
  'form.request.descHint.CONSULTA': 'Mínimo 10 caracteres. Cuéntanos qué deseas saber o qué aspecto del Proyecto quieres aclarar.',
  'form.request.descHint.SUGERENCIA': 'Mínimo 10 caracteres. Cuéntanos tu idea o propuesta y cómo consideras que podría ayudar.',
  'form.request.descHint.PREOCUPACION': 'Mínimo 10 caracteres. Cuéntanos qué situación te preocupa, dónde ocurrió y por qué consideras importante que la revisemos.',
  'form.request.descHint.QUEJA_RECLAMO': 'Mínimo 10 caracteres. Cuéntanos qué ocurrió, cuándo y dónde sucedió, y qué consideras que debería atenderse.',
  'form.request.expectation': 'Si deseas, cuéntanos qué esperas que haga el Proyecto para atender esta situación.',

  // Relationship with the project
  'relation.heading': 'Para ayudarnos a comprender tu solicitud (opcional)',
  'relation.type': '¿Cuál es tu relación con el Proyecto?',
  'relation.subtype': 'Precisa tu relación',
  'relation.other': 'Describe tu relación con el Proyecto',
  'relation.type.PARTICIPANTE_COMUNIDAD': 'Participante o comunidad',
  'relation.type.ORGANIZACIONES_PROVEEDORES': 'Organizaciones y proveedores',
  'relation.type.INSTITUCIONES_OTROS': 'Instituciones y otros actores',
  'relation.type.OTRO': 'Otro',
  'relation.type.NO_ESPECIFICA': 'Prefiero no especificar',
  'relation.sub.PRODUCTOR_PARTICIPANTE': 'Productor/a participante',
  'relation.sub.MIEMBRO_COMUNIDAD': 'Miembro de una comunidad local',
  'relation.sub.VECINO_AFECTADO': 'Vecino/a o persona potencialmente afectada',
  'relation.sub.ORG_SOCIA': 'Representante de una organización socia del proyecto',
  'relation.sub.ORG_LOCAL': 'Representante de una organización local',
  'relation.sub.PROVEEDOR_CONTRATISTA': 'Proveedor/a o contratista',
  'relation.sub.TRABAJADOR_PROYECTO': 'Trabajador/a o colaborador/a del Proyecto',
  'relation.sub.AUTORIDAD_PUBLICA': 'Autoridad o institución pública',
  'relation.sub.SOCIEDAD_CIVIL': 'Organización de la sociedad civil',
  'relation.sub.TITULAR_TIERRAS': 'Propietario/a o titular de derechos sobre la tierra',

  // Files
  'files.heading': '¿Tienes alguna foto, documento o evidencia que quieras compartir?',
  'files.add': 'Adjuntar una foto o documento',
  'files.hint': 'JPG, PNG o PDF · Máximo {max} MB',

  // Location
  'form.location.heading': '¿Dónde ocurrió o a qué lugar se refiere tu solicitud?',
  'form.location.intro': 'Indica el lugar relacionado con tu solicitud. Puedes seleccionar una comunidad, localidad o zona del Proyecto.',
  'form.location.sector': 'Sector, caserío o comunidad',
  'loc.region': 'Región del área del Proyecto',
  'loc.province': 'Provincia del área del Proyecto',
  'loc.district': 'Distrito del área del Proyecto',
  'loc.otherRegion': 'Otro',

  // Review
  'form.review.heading': 'Revisa tu solicitud antes de enviarla',
  'form.review.anonymousBadge': 'Solicitud anónima',
  'form.review.identifiedBadge': 'Solicitud con datos de contacto',
  'form.review.verify': 'Verifica que la información sea correcta. Si necesitas hacer algún cambio, puedes volver atrás antes de enviarla.',
  'form.review.contactTitle': 'Tus datos de contacto',
  'form.review.requestTitle': 'Tu solicitud',
  'form.review.type': 'Tipo',
  'form.review.description': 'Descripción',
  'form.review.location': 'Ubicación relacionada con la solicitud',
  'form.review.files': 'Archivos adjuntos',
  'form.review.filesCount': '{n} archivo(s)',
  'form.review.noFiles': 'Ninguno',
  'form.review.relation': 'Relación con el Proyecto',
  'form.review.consentTitle': 'Tratamiento de datos personales',
  'form.review.consentText': 'He leído la información sobre el uso y protección de mis datos personales.',
  'form.review.consentAnonymousText': 'Confirmo que deseo enviar esta solicitud de manera anónima.',
  'form.review.anonymousInfo': 'Al enviar una solicitud anónima, no se registrarán tus datos personales de contacto. Por ello, no podremos comunicarnos contigo directamente ni enviarte una respuesta personalizada.',
  'form.review.identifiedInfo': 'Al proporcionar tus datos de contacto, podremos comunicarnos contigo si necesitamos información adicional y brindarte una respuesta sobre tu solicitud.',
  'form.review.trackingInfo': 'Recibirás un código de seguimiento que podrás utilizar para consultar el estado de tu solicitud.',
  'form.submit': 'Enviar solicitud',

  // Confirmation
  'success.heading': '¡Tu solicitud ha sido recibida!',
  'success.thanks': 'Gracias por comunicarte con el Proyecto Jubilación Segura.',
  'success.keepCode': 'Guarda este código en un lugar seguro. Lo necesitarás para consultar el estado de tu solicitud.',
  'success.whatNow': '¿Qué puedes hacer ahora?',
  'success.track': 'Consultar estado de mi solicitud',
  'success.another': 'Registrar otra solicitud',
  'success.uploadFailed': 'No se pudieron subir {n} archivo(s). Puedes intentar adjuntarlos de nuevo aquí.',

  // Errors
  'error.contactRequired': 'Indica al menos un teléfono o un correo.',
  'error.dateInFuture': 'La fecha no puede ser futura.',
  'error.CONTACT_REQUIRED': 'Indica al menos un teléfono o un correo.',
  'error.ID_DOCUMENT_INCOMPLETE': 'Indica el tipo y el número del documento, o ninguno de los dos.',
  'error.RELATION_OTHER_REQUIRED': 'Describe tu relación con el Proyecto.',
  'error.RELATION_SUBTYPE_REQUIRED': 'Precisa tu relación con el Proyecto.',
  'error.ORG_NOT_IN_PROJECT': 'Esa organización no pertenece al proyecto seleccionado.',
  'error.DATE_IN_FUTURE': 'La fecha no puede ser futura.',
  'error.RECEPTION_EVIDENCE_REQUIRED': 'Indica el tipo de evidencia de recepción.',
  'error.RECEPTION_RECORD_REQUIRED': 'Completa el registro interno de recepción.',
  'error.TEAM_REQUIRED': 'Indica al menos una persona del equipo técnico del proyecto.',
  'error.REPORTER_NAME_REQUIRED': 'Indica el nombre de quien registra.',
  'error.OTHER_PLACE_REQUIRED': 'Detalla el lugar del evento.',
  'error.ORG_NOT_ALLOWED_FOR_EVENTS': 'Esa entidad no puede reportar eventos.',

  // Organisations, channels, places, proofs
  'org.FLOR_DE_CAFE': 'FLOR DE CAFE',
  'org.VALLE_VERDE': 'VALLE VERDE',
  'org.APROEXPORT': 'APROEXPORT',
  'org.APROCOYCE': 'APROCOYCE',
  'channel.ONLINE_FORM': 'Formulario en línea',
  'channel.MAILBOX': 'Buzones físicos MACQR (organizaciones socias o viveros)',
  'channel.COMPLAINTS_BOOK': 'Libro de reclamaciones (organizaciones socias o viveros)',
  'channel.EMAIL': 'Correo electrónico',
  'channel.WEBSITE': 'Sitio web',
  'channel.EVENT_BOX': 'Caja MACQR en eventos',
  'channel.PAPER_FORM': 'Formulario físico recogido en visitas técnicas de campo',
  'channel.PHONE_CALL': 'Llamada telefónica',
  'channel.IN_PERSON': 'Atención presencial',
  'place.OFICINA_SOCIOS': 'Oficina de organizaciones socias',
  'place.OFICINA_VIVEROS': 'Oficina de viveros',
  'place.COMUNIDAD': 'Comunidad o centro poblado',
  'proof.FORMATO_MACQR': 'Formato físico del MACQR (foto escaneada)',
  'proof.CORREO_REGISTRO_WEB': 'Captura/PDF del correo o registro web recibido',
  'proof.LIBRO_ACTAS': 'Fotografía o escaneo del libro de reclamaciones o actas de reunión',
  'proof.CAPTURA_MENSAJE': 'Captura de mensaje recibido (celular)',
  'proof.REGISTRO_INTERNO': 'Registro interno de recepción',
  'proof.OTRO': 'Otro',

  // Internal form
  'internal.heading': 'Registrar una solicitud recibida por otro canal',
  'internal.intro': 'Formulario interno que incorpora al sistema una consulta, sugerencia, queja o reclamo recibido por el Proyecto a través de otro canal.',
  'internal.section.origin': 'Datos de recepción',
  'internal.section.originHelp': 'Registra cómo y cuándo fue recibida la solicitud por el Proyecto. Esta información permite hacer seguimiento a su origen y canal de ingreso.',
  'internal.who': '¿Quién registra?',
  'internal.registeredByName': 'Nombre del personal del proyecto que está registrando la solicitud',
  'internal.registeredByEmail': 'Correo del personal del proyecto que está registrando la solicitud',
  'internal.registeredByOrg': 'Organización / Equipo que recibe',
  'internal.how': 'Cómo llegó la solicitud',
  'internal.channel': 'Canal de ingreso',
  'internal.receptionPlace': 'Lugar o punto de recepción',
  'internal.presentedAt': 'Fecha de recepción',
  'internal.presentedAtHint': 'Fecha en que el Proyecto recibió la solicitud por primera vez.',
  'internal.registeredAt': 'Fecha de registro en el sistema',
  'internal.automatic': 'Automático',
  'internal.proof.heading': 'Evidencia de recepción',
  'internal.proof.question': '¿Tienes un archivo que acredita la recepción?',
  'internal.proof.yes': 'Sí → adjuntar archivo (obligatorio)',
  'internal.proof.no': 'No → completar el registro interno de recepción (obligatorio)',
  'internal.proof.kind': 'Tipo de evidencia',
  'internal.proof.attachHelp': 'Adjunta un archivo que permita acreditar cómo fue recibida esta solicitud.',
  'internal.proof.attach': 'Adjuntar evidencia',
  'internal.proof.formats': 'Foto, captura de pantalla, PDF, documento. Formatos permitidos: JPG, PNG, PDF · Tamaño máximo: {max} MB',
  'internal.proof.examples': 'Ejemplos: foto del Formato físico del MACQR recibido en buzón, eventos o visitas técnicas; captura de un correo o mensaje recibido; fotografía de una página del libro de reclamaciones u otro documento que acredite la recepción.',
  'internal.proof.required': 'Adjunta al menos un archivo que acredite la recepción.',
  'internal.record.heading': 'Registro interno de recepción',
  'internal.record.help': 'Completa esta sección cuando la solicitud fue recibida verbalmente o cuando no existe un documento o archivo que permita acreditar su recepción.',
  'internal.record.date': 'Fecha de recepción',
  'internal.record.time': 'Hora de recepción',
  'internal.record.medium': 'Medio de recepción',
  'internal.record.by': 'Persona que recibió la solicitud',
  'internal.record.role': 'Cargo o función',
  'internal.record.description': '¿Cómo fue recibida la solicitud?',
  'internal.record.descriptionHint': 'Describe brevemente cómo se recibió la solicitud, incluyendo quién la presentó y el contexto en el que fue comunicada. Ejemplo: la persona solicitante comunicó verbalmente su preocupación durante una visita del equipo técnico a la comunidad.',
  'internal.record.saved': 'Una vez guardado, este registro quedará asociado a la solicitud como evidencia de recepción.',
  'internal.person.heading': 'Datos de la persona solicitante',
  'internal.person.question': '¿La persona solicitante proporcionó sus datos?',
  'internal.person.yes': 'Sí, dejó sus datos',
  'internal.person.no': 'No, la solicitud es anónima',
  'internal.person.idNotice': 'No es necesario proporcionar el documento de identidad para presentar la solicitud.',
  'internal.relation.heading': 'Relación con el proyecto',
  'internal.relation.question': '¿Cuál es la relación de la persona solicitante con el Proyecto?',
  'internal.desc.heading': 'Descripción de la solicitud',
  'internal.desc.help': 'Registra lo expresado por la persona solicitante de la manera más clara y objetiva posible.',
  'internal.desc.label': '¿Qué comunicó la persona solicitante?',
  'internal.desc.hint': 'Mínimo 10 caracteres. Si los conoces, indica qué ocurrió, cuándo y dónde. Si se conoce, indica qué espera como solución a su solicitud.',
  'internal.desc.files': '¿Tienes alguna foto, documento o evidencia que el solicitante haya compartido junto a su solicitud?',
  'internal.location.heading': 'Ubicación relacionada con la solicitud',
  'internal.location.help': 'No es necesario que corresponda al domicilio de la persona solicitante: indica el lugar al que se refiere la solicitud.',
  'internal.consent': 'Confirmo que la persona solicitante fue informada del tratamiento de sus datos personales y dio su consentimiento en el registro físico (o por el medio por el que presentó su solicitud).',
  'internal.submit': 'Registrar solicitud',
  'internal.done.heading': '¡Solicitud registrada correctamente!',
  'internal.done.text': 'La solicitud ha sido incorporada al Mecanismo de Atención del Proyecto.',
  'internal.done.evidence': 'Evidencia de recepción adjunta',
  'internal.done.give': 'Entrega este código a la persona solicitante. Le permitirá consultar el estado de su solicitud posteriormente.',
  'internal.done.important': 'Importante: conserva este código junto con la información de la solicitud. Es el identificador que permitirá realizar el seguimiento.',
  'internal.done.anonymous': 'Si la solicitud es anónima, este código es la única forma de consultar su estado.',
  'internal.done.view': 'Ver solicitud registrada',
  'internal.done.another': 'Registrar otra solicitud',

  // Entry pages of the two staff forms
  'entry.request.title': 'REGISTRAR UNA SOLICITUD RECIBIDA POR OTRO CANAL',
  'entry.request.intro': 'Incorpora al sistema una consulta, sugerencia, queja o reclamo recibido por el Proyecto a través de otro canal.',
  'entry.request.new': 'Registrar una nueva solicitud',
  'entry.request.newHint': 'Ingresa los datos de la solicitud recibida para generar su código de seguimiento.',
  'entry.request.query': 'Consultar solicitudes registradas',
  'entry.request.queryHint': 'Busca una solicitud por código, fecha o estado de atención.',
  'entry.request.whatTitle': '¿Qué solicitudes debes registrar?',
  'entry.request.whatText': 'Todas las consultas, sugerencias, preocupaciones, quejas o reclamos relacionados con el Proyecto que hayan sido recibidos por otros canales, por ejemplo: buzones físicos, libros de reclamaciones, atención presencial (visitas técnicas o eventos), correo electrónico, página web, teléfono u otros medios habilitados.',
  'entry.event.title': 'REGISTRAR UN EVENTO',
  'entry.event.intro': 'Incorpora al sistema solo eventos finalizados. Ten a la mano la lista de asistencia escaneada, máximo 3 fotos, y si aplica acta, video o algún otro medio de verificación.',
  'entry.event.new': 'Registrar un evento',
  'entry.event.newHint': 'Ingresa los datos del evento finalizado.',
  'entry.event.query': 'Consultar eventos registrados',
  'entry.event.queryHint': 'Busca por organización y fecha del evento.',

  // Events
  'component.DISTRIBUCION_CARBONO': 'Distribución de beneficios del carbono',
  'component.MACQR': 'Mecanismo de atención (MACQR)',
  'technical.REUNION_TECNICA': 'Reunión técnica mensual',
  'fev.intro': 'Incorpora al sistema solo eventos finalizados. Ten a la mano la lista de asistencia escaneada, máximo 3 fotos, y si aplica acta, video o algún otro medio de verificación.',
  'fev.who': '¿Quién registra?',
  'fev.reportedByName': 'Nombre del personal del proyecto que está registrando el evento',
  'fev.reportedByEmail': 'Correo del personal del proyecto que está registrando el evento',
  'fev.contractWave': 'Contrato u ola relacionada al evento',
  'fev.teamHelp': 'Completa al menos un campo: miembros del equipo técnico del proyecto (todas las entidades) que participaron en el evento. Ya están incluidos en el total de participantes.',
  'fev.attachments.beforeRegister': 'Los medios de verificación deben adjuntarse antes de registrar el evento. La lista de asistencia es obligatoria; añade fotos (máximo 3), y si aplica acta, video u otros documentos.',
  'fev.attachments.attendanceRequired': 'Adjunta al menos la lista de asistencia escaneada.',
};
